import React from 'react';
import PropTypes from 'prop-types';
import {Box} from '@material-ui/core';
import propTypes from 'helpers/propTypes';

const CheckForUnderstanding = ({gutterBottom, className, children, ...rest}) => (
  <Box marginBottom={gutterBottom ? 4 : 0} className={className} {...rest}>
    {children}
  </Box>
);

CheckForUnderstanding.propTypes = {
  className: PropTypes.string,
  gutterBottom: PropTypes.bool,
  page: propTypes.page,
};

export default CheckForUnderstanding;
